"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import FormSelect from "./webflow_modules/Form/components/FormSelect";

export function AdvSearchMoveInDropdown({ runtimeProps = {} }) {
  return (
    <Block className={"move-in-group"} tag={"div"}>
      <Block className={" adv-search-lable"} tag={"div"}>
        {"Move-in"}
      </Block>
      <Block className={"input-dropdown"} tag={"div"}>
        <Block className={"adv-search-drop-down-wrapper"} tag={"div"}>
          <FormSelect
            className={"adv-search-dropdown"}
            data-name={"Move-In-Date"}
            id={"Move-In-Date"}
            multiple={false}
            name={"Move-In-Date"}
            options={[
              {
                t: "Next 7 Days",
                v: "<7",
              },
              {
                t: "Next 15 Days",
                v: "<16",
              },
              {
                t: "Next 30 Days",
                v: "<31",
              },
              {
                t: "After 30 Days",
                v: ">30",
              },
            ]}
            required={false}
            {...runtimeProps}
          />
        </Block>
      </Block>
    </Block>
  );
}
